// hooks
import { useQuery } from 'react-query';
import { getFlexMatchTasks } from 'RestAPIs/flex-match';

const useGetFlexMatchTasks = (
  { filters, page, pageSize },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['flexMatchTasks', filters, page, pageSize],
    async () => {
      const rangeStart = page * pageSize;
      const rangeEnd = rangeStart + pageSize - 1;

      const { data, headers } = await getFlexMatchTasks({
        filters,
        rangeStart,
        rangeEnd
      });

      const totalItems = headers['content-range']?.split('/')[1];

      return { data, totalItems: parseInt(totalItems, 10) };
    },
    { keepPreviousData: true, ...options }
  );
};

export default useGetFlexMatchTasks;
